const translations = {
  fr: {
    "dashboard": "Tableau de Bord",
    "users": "Utilisateurs",
    "employees": "Employes & Roles",
    "billing": "Facturation",
    "interviews": "Entretiens",
    "logs": "Journaux Systeme",
    "testimonials": "Temoignages",
    "ai_monitor": "Moniteur IA",
    "overview": "Vue d'ensemble",
    "total_companies": "Entreprises",
    "completed_interviews": "Entretiens Realises",
    "revenue": "Revenu Total",
    "mrr": "Revenu Mensuel",
    "api_usage": "Utilisation API",
    "recent_signups": "Dernieres Inscriptions",
    "system_health": "Sante Systeme",
    "operational": "Operationnel",
    "suspend": "Suspendre",
    "reactivate": "Reactiver",
    "delete": "Supprimer",
    "edit": "Modifier",
    "role": "Role",
    "credits": "Credits",
    "status": "Statut",
    "actions": "Actions",
    "name": "Nom",
    "email": "Email",
    "permissions": "Permissions",
    "add_employee": "Ajouter Employe",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "logout": "Deconnexion",
    "super_admin": "Super Admin",
    "admin_employee": "Employe Admin",
    "recruiter": "Recruteur",
    "active": "Actif",
    "suspended": "Suspendu",
    "welcome": "Bienvenue",
    "admin_console": "Console Admin",
    "secure_access": "Acces securise Super-Admin & Equipes",
    "login": "Connexion",
    "signup": "Inscription",
    "password": "Mot de passe",
    "confirm_password": "Confirmer le mot de passe",
    "continue_google": "Continuer avec Google (Super Admin)",
    "search": "Rechercher...",
    "confirm_delete": "Etes-vous sur de vouloir supprimer ?",
    "warning_delete": "Cette action est irreversible.",
    "billing_history": "Historique Facturation",
    "amount": "Montant",
    "date": "Date",
    "logs_system": "Journaux Systeme",
    "level": "Niveau",
    "message": "Message",
    "timestamp": "Horodatage",
    "interviews_monitoring": "Suivi Entretiens",
    "candidate": "Candidat",
    "score": "Score",
    "duration": "Duree",
    "view_video": "Voir Video",
    "no_video": "Pas de video",
    "minutes": "min",
    "seconds": "sec",
    "job": "Poste",
    "company": "Entreprise",
    "gift_credits": "Offrir Credits",
    "sort_asc": "Tri croissant",
    "sort_desc": "Tri decroissant",
    "session_id": "ID Session",
    "recruiter_name": "Recruteur",
    "candidate_name": "Candidat",
    "real_duration": "Duree reelle",
    "video": "Video",
    "pending": "En attente",
    "approved": "Approuve",
    "rejected": "Rejete",
    "moderate": "Moderer",
    "approve": "Approuver",
    "reject": "Rejeter",
    "content": "Contenu",
    "rating": "Note",
    "author": "Auteur",
    "total_revenue": "Revenu Total",
    "transactions": "Transactions",
    "package": "Pack",
    "clear_logs": "Vider les logs",
    "signup_desc": "Configurez votre mot de passe (compte pre-enregistre)",
    "set_password": "Configurer Mot de Passe",
    "no_data": "Aucune donnee",
    "interviews_chart": "Entretiens (14 jours)",
    "revenue_chart": "Revenus (14 jours)",
    "users_chart": "Inscriptions (14 jours)",
    "total_employees": "Employes Admin",
    "pending_testimonials": "Temoignages en attente",
    "loading": "Chargement...",
    "sign_in": "Se connecter",
    "employee_signup": "Inscription Employe",
    "enter_admin_credentials": "Entrez vos identifiants administrateur",
    "signup_employee_desc": "Configurez votre mot de passe (compte pre-enregistre par l'admin)",
    "professional_email": "Email Professionnel",
    "access_denied": "Acces non autorise. Ce portail est reserve aux administrateurs.",
    "incorrect_credentials": "Identifiants incorrects",
    "connection_error": "Erreur de connexion",
    "passwords_mismatch": "Les mots de passe ne correspondent pas",
    "password_min_length": "Le mot de passe doit contenir au moins 6 caracteres",
    "password_configured": "Mot de passe configure ! Vous pouvez vous connecter.",
    "signup_error": "Erreur lors de l'inscription",
    "server_error": "Erreur de connexion au serveur",
    "ai_monitor_title": "Moniteur IA",
    "ai_monitor_subtitle": "Surveillance en temps reel de l'utilisation des APIs IA",
    "refresh": "Actualiser",
    "total_calls": "Appels totaux",
    "today_calls": "Appels aujourd'hui",
    "week_calls": "Appels cette semaine",
    "total_cost": "Cout total",
    "month_cost": "Cout mensuel",
    "error_rate": "Taux d'erreur",
    "usage_by_service": "Utilisation par service",
    "service": "Service",
    "operation": "Operation",
    "calls": "Appels",
    "cost": "Cout",
    "avg_latency": "Latence moy.",
    "success_rate": "Taux succes",
    "daily_usage": "Utilisation quotidienne (30 jours)",
    "recent_calls": "Appels recents",
    "cost_distribution": "Repartition des couts",
    "no_ai_data": "Aucune donnee IA disponible",
    "user_deleted": "Utilisateur supprime",
    "employee_created": "Employe cree",
    "employee_updated": "Employe modifie",
    "employee_deleted": "Employe supprime",
    "transaction_deleted": "Transaction supprimee",
    "testimonial_deleted": "Temoignage supprime",
    "logs_cleared": "Logs vides",
    "interview_deleted": "Entretien supprime",
    "error_generic": "Erreur"
  },
  en: {
    "dashboard": "Dashboard",
    "users": "Users",
    "employees": "Employees & Roles",
    "billing": "Billing",
    "interviews": "Interviews",
    "logs": "System Logs",
    "testimonials": "Testimonials",
    "ai_monitor": "AI Monitor",
    "overview": "Overview",
    "total_companies": "Companies",
    "completed_interviews": "Completed Interviews",
    "revenue": "Total Revenue",
    "mrr": "Monthly Revenue",
    "api_usage": "API Usage",
    "recent_signups": "Recent Signups",
    "system_health": "System Health",
    "operational": "Operational",
    "suspend": "Suspend",
    "reactivate": "Reactivate",
    "delete": "Delete",
    "edit": "Edit",
    "role": "Role",
    "credits": "Credits",
    "status": "Status",
    "actions": "Actions",
    "name": "Name",
    "email": "Email",
    "permissions": "Permissions",
    "add_employee": "Add Employee",
    "save": "Save",
    "cancel": "Cancel",
    "logout": "Logout",
    "super_admin": "Super Admin",
    "admin_employee": "Admin Employee",
    "recruiter": "Recruiter",
    "active": "Active",
    "suspended": "Suspended",
    "welcome": "Welcome",
    "admin_console": "Admin Console",
    "secure_access": "Secure Access Super-Admin & Teams",
    "login": "Login",
    "signup": "Sign Up",
    "password": "Password",
    "confirm_password": "Confirm password",
    "continue_google": "Continue with Google (Super Admin)",
    "search": "Search...",
    "confirm_delete": "Are you sure you want to delete?",
    "warning_delete": "This action cannot be undone.",
    "billing_history": "Billing History",
    "amount": "Amount",
    "date": "Date",
    "logs_system": "System Logs",
    "level": "Level",
    "message": "Message",
    "timestamp": "Timestamp",
    "interviews_monitoring": "Interview Monitoring",
    "candidate": "Candidate",
    "score": "Score",
    "duration": "Duration",
    "view_video": "View Video",
    "no_video": "No video",
    "minutes": "min",
    "seconds": "sec",
    "job": "Job",
    "company": "Company",
    "gift_credits": "Gift Credits",
    "sort_asc": "Sort ascending",
    "sort_desc": "Sort descending",
    "session_id": "Session ID",
    "recruiter_name": "Recruiter",
    "candidate_name": "Candidate",
    "real_duration": "Real Duration",
    "video": "Video",
    "pending": "Pending",
    "approved": "Approved",
    "rejected": "Rejected",
    "moderate": "Moderate",
    "approve": "Approve",
    "reject": "Reject",
    "content": "Content",
    "rating": "Rating",
    "author": "Author",
    "total_revenue": "Total Revenue",
    "transactions": "Transactions",
    "package": "Package",
    "clear_logs": "Clear Logs",
    "signup_desc": "Set up your password (pre-registered account)",
    "set_password": "Set Password",
    "no_data": "No data",
    "interviews_chart": "Interviews (14 days)",
    "revenue_chart": "Revenue (14 days)",
    "users_chart": "Signups (14 days)",
    "total_employees": "Admin Employees",
    "pending_testimonials": "Pending Testimonials",
    "loading": "Loading...",
    "sign_in": "Sign In",
    "employee_signup": "Employee Sign Up",
    "enter_admin_credentials": "Enter your admin credentials",
    "signup_employee_desc": "Set up your password (pre-registered by admin)",
    "professional_email": "Professional Email",
    "access_denied": "Unauthorized access. This portal is reserved for administrators.",
    "incorrect_credentials": "Incorrect credentials",
    "connection_error": "Connection error",
    "passwords_mismatch": "Passwords do not match",
    "password_min_length": "Password must be at least 6 characters",
    "password_configured": "Password set! You can now sign in.",
    "signup_error": "Sign up error",
    "server_error": "Server connection error",
    "ai_monitor_title": "AI Monitor",
    "ai_monitor_subtitle": "Real-time monitoring of AI API usage",
    "refresh": "Refresh",
    "total_calls": "Total Calls",
    "today_calls": "Today's Calls",
    "week_calls": "This Week",
    "total_cost": "Total Cost",
    "month_cost": "Monthly Cost",
    "error_rate": "Error Rate",
    "usage_by_service": "Usage by Service",
    "service": "Service",
    "operation": "Operation",
    "calls": "Calls",
    "cost": "Cost",
    "avg_latency": "Avg Latency",
    "success_rate": "Success Rate",
    "daily_usage": "Daily Usage (30 days)",
    "recent_calls": "Recent Calls",
    "cost_distribution": "Cost Distribution",
    "no_ai_data": "No AI data available",
    "user_deleted": "User deleted",
    "employee_created": "Employee created",
    "employee_updated": "Employee updated",
    "employee_deleted": "Employee deleted",
    "transaction_deleted": "Transaction deleted",
    "testimonial_deleted": "Testimonial deleted",
    "logs_cleared": "Logs cleared",
    "interview_deleted": "Interview deleted",
    "error_generic": "Error"
  },
  es: {
    "dashboard": "Panel de Control",
    "users": "Usuarios",
    "employees": "Empleados y Roles",
    "billing": "Facturacion",
    "interviews": "Entrevistas",
    "logs": "Registros del Sistema",
    "testimonials": "Testimonios",
    "ai_monitor": "Monitor IA",
    "overview": "Vision General",
    "total_companies": "Empresas",
    "completed_interviews": "Entrevistas Completadas",
    "revenue": "Ingreso Total",
    "mrr": "Ingreso Mensual",
    "api_usage": "Uso de API",
    "recent_signups": "Registros Recientes",
    "system_health": "Estado del Sistema",
    "operational": "Operacional",
    "suspend": "Suspender",
    "reactivate": "Reactivar",
    "delete": "Eliminar",
    "edit": "Editar",
    "role": "Rol",
    "credits": "Creditos",
    "status": "Estado",
    "actions": "Acciones",
    "name": "Nombre",
    "email": "Email",
    "permissions": "Permisos",
    "add_employee": "Anadir Empleado",
    "save": "Guardar",
    "cancel": "Cancelar",
    "logout": "Cerrar Sesion",
    "super_admin": "Super Admin",
    "admin_employee": "Empleado Admin",
    "recruiter": "Reclutador",
    "active": "Activo",
    "suspended": "Suspendido",
    "welcome": "Bienvenido",
    "admin_console": "Consola de Administracion",
    "secure_access": "Acceso Seguro Super-Admin y Equipos",
    "login": "Iniciar Sesion",
    "signup": "Registrarse",
    "password": "Contrasena",
    "confirm_password": "Confirmar contrasena",
    "continue_google": "Continuar con Google (Super Admin)",
    "search": "Buscar...",
    "confirm_delete": "Esta seguro de que desea eliminar?",
    "warning_delete": "Esta accion no se puede deshacer.",
    "billing_history": "Historial de Facturacion",
    "amount": "Cantidad",
    "date": "Fecha",
    "logs_system": "Registros del Sistema",
    "level": "Nivel",
    "message": "Mensaje",
    "timestamp": "Marca de tiempo",
    "interviews_monitoring": "Monitoreo de Entrevistas",
    "candidate": "Candidato",
    "score": "Puntuacion",
    "duration": "Duracion",
    "view_video": "Ver Video",
    "no_video": "Sin video",
    "minutes": "min",
    "seconds": "seg",
    "job": "Puesto",
    "company": "Empresa",
    "gift_credits": "Regalar Creditos",
    "sort_asc": "Orden ascendente",
    "sort_desc": "Orden descendente",
    "session_id": "ID Sesion",
    "recruiter_name": "Reclutador",
    "candidate_name": "Candidato",
    "real_duration": "Duracion real",
    "video": "Video",
    "pending": "Pendiente",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "moderate": "Moderar",
    "approve": "Aprobar",
    "reject": "Rechazar",
    "content": "Contenido",
    "rating": "Calificacion",
    "author": "Autor",
    "total_revenue": "Ingreso Total",
    "transactions": "Transacciones",
    "package": "Paquete",
    "clear_logs": "Vaciar registros",
    "signup_desc": "Configure su contrasena (cuenta pre-registrada)",
    "set_password": "Configurar Contrasena",
    "no_data": "Sin datos",
    "interviews_chart": "Entrevistas (14 dias)",
    "revenue_chart": "Ingresos (14 dias)",
    "users_chart": "Registros (14 dias)",
    "total_employees": "Empleados Admin",
    "pending_testimonials": "Testimonios pendientes",
    "loading": "Cargando...",
    "sign_in": "Iniciar sesion",
    "employee_signup": "Registro de Empleado",
    "enter_admin_credentials": "Ingrese sus credenciales de administrador",
    "signup_employee_desc": "Configure su contrasena (cuenta pre-registrada por el admin)",
    "professional_email": "Email Profesional",
    "access_denied": "Acceso no autorizado. Este portal es solo para administradores.",
    "incorrect_credentials": "Credenciales incorrectas",
    "connection_error": "Error de conexion",
    "passwords_mismatch": "Las contrasenas no coinciden",
    "password_min_length": "La contrasena debe tener al menos 6 caracteres",
    "password_configured": "Contrasena configurada! Ya puede iniciar sesion.",
    "signup_error": "Error de registro",
    "server_error": "Error de conexion al servidor",
    "ai_monitor_title": "Monitor IA",
    "ai_monitor_subtitle": "Monitoreo en tiempo real del uso de APIs de IA",
    "refresh": "Actualizar",
    "total_calls": "Llamadas totales",
    "today_calls": "Llamadas hoy",
    "week_calls": "Esta semana",
    "total_cost": "Costo total",
    "month_cost": "Costo mensual",
    "error_rate": "Tasa de error",
    "usage_by_service": "Uso por servicio",
    "service": "Servicio",
    "operation": "Operacion",
    "calls": "Llamadas",
    "cost": "Costo",
    "avg_latency": "Latencia prom.",
    "success_rate": "Tasa exito",
    "daily_usage": "Uso diario (30 dias)",
    "recent_calls": "Llamadas recientes",
    "cost_distribution": "Distribucion de costos",
    "no_ai_data": "Sin datos de IA disponibles",
    "user_deleted": "Usuario eliminado",
    "employee_created": "Empleado creado",
    "employee_updated": "Empleado actualizado",
    "employee_deleted": "Empleado eliminado",
    "transaction_deleted": "Transaccion eliminada",
    "testimonial_deleted": "Testimonio eliminado",
    "logs_cleared": "Registros vaciados",
    "interview_deleted": "Entrevista eliminada",
    "error_generic": "Error"
  }
};

export default translations;
